import * as React from 'react';
import { Schema, SchemaField } from '../../types/Metadata';
import { Typeahead } from '../Typeahead/typeahead';
import { SROpts } from '../../types/SROpts';
import { cn } from '../../utils';
import { useSelector } from '../../utils/useSelector';

interface Props {
  selected?: SchemaField | string;
  isChecked?: (s: Schema) => boolean;
  excludeSchemas?: Schema[] | string[];
  onSelectSchema?: (s: Schema, opts?: SROpts) => boolean | any;
  onTextChange?: (t: string) => void;
  inline?: boolean;
  flat?: boolean;
  disabled?: boolean;
  children?: any;
}

export const SchemaTypeahead = ({
  selected,
  excludeSchemas,
  children,
  onTextChange,
  disabled,
  inline,
  flat,
  ...props
}: Props) => {
  const schemas =
    useSelector(s => s.planning?.selectedWorkspace?.schemas) || [];
  const excludes: string[] = [];
  if (Array.isArray(excludeSchemas)) {
    excludeSchemas?.forEach(es => {
      if (typeof es == 'string') excludes.push(es);
    });
  }
  const options = schemas;
  const value = typeof selected == 'string' ? selected : selected?.displayName;
  return (
    <Typeahead
      className={cn('typeahead-schema-field', {
        'typeahead-check': !!props.isChecked,
        'typeahead-tree': !flat
      })}
      inline={inline}
      options={options}
      value={value}
      {...{ children, onTextChange }}
      disabled={disabled}
      renderSearchResult={(matched, opts) => {
        if (opts) {
          const { noMatchMessage, text, children } = opts;

          if (!!text && matched?.length === 0) {
            return (
              <>
                {!!children && <div>{children}</div>}
                {noMatchMessage}
              </>
            );
          }
          const _schemas = matched?.length ? matched : options;
          return (
            <>
              {!!children && <div>{children}</div>}
              <div className="scrollable">
                <FlatList schemas={_schemas} {...props} opts={opts} />
              </div>
            </>
          );
        }
      }}
      includes={(t, { props }) =>
        props?.name?.toLowerCase().includes(t?.trim().toLowerCase())
      }
    />
  );
};

type FieldProps = Pick<Props, 'onSelectSchema' | 'isChecked'> & {
  opts: SROpts;
  schemas: Schema[];
};

const FlatList = ({ onSelectSchema, opts, schemas, isChecked }: FieldProps) => {
  return (
    <ul className="dd-list">
      {schemas.map(curr => {
        return (
          <li
            className={cn({ 'dd-checked': !!isChecked && isChecked(curr) })}
            key={curr.id}
            onClick={
              !onSelectSchema
                ? null
                : () => {
                    if (!!opts && !onSelectSchema(curr, opts))
                      opts.hideDropdown();
                  }
            }
          >
            <span>{curr.props?.name}</span>
          </li>
        );
      })}
    </ul>
  );
};
